export const emptyDominationFormData = {
  firstName: '',
  lastName: '',
  email: '',
  experienceLevel: '',
  phoneNumber: '',
  sessionInterests: '',
  hardLimits: '',
  location: '',
  message: '',
  haveWeMet: '',        // NEW
  whenWhere: '',        // NEW
};

export const emptyBabyFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  location: '',
  agePlayLevel: '',
  diaperUse: '',
  caregiverNeeds: '',
  experience: '',
  fetishes: '',
  limits: '',
  message: '',
  haveWeMet: '',     // NEW
  whenWhere: '',     // NEW
};
